import { Col, Layout, Row } from "antd";
import { useState } from "react";
import CardPortfolio from "./components/card-portfolio/CardPortfolio";
import CardPortfolioValue from "./components/card-portfolio-value/CardPortfolioValue";
import "./portfolio-value-management.scss";

type PortfolioValueManagementProps = {
  title?: string;
};

const PortfolioValueManagement = ({ title }: PortfolioValueManagementProps) => {
const [listDataPortfolio, setListDataPortfolio] = useState([]);
  const [portfolioIdValue, setPortfolioIdValue] = useState<number | string | null>(null);
  const [dataPortfolioValue, setDataPortfolioValue] = useState<any>([]);
  const [dataOptions, setDataOptions] = useState({
    dataPortfolio: [],
    dataPortfolioValue: []
  });

  return (
    <Layout className="page-header-group page-header-portfolio ">
        <Row className="row-card">
          <Col xl={{span: 7}} md={{span: 7}} sm={{span: 24}} xs={{span: 24}} className="col-card-portfolio">
            <CardPortfolio 
              listDataPortfolio={listDataPortfolio}
              setPortfolioIdValue={setPortfolioIdValue}
            />
          </Col>
          <Col xl={{span: 16}} md={{span: 16}} sm={{span: 24}} xs={{span: 24}} className="col-card-portfolio-value">
            <CardPortfolioValue
              title={title}
              portfolioIdValue={portfolioIdValue}
              dataPortfolioValue={dataPortfolioValue}
              setDataPortfolioValue={setDataPortfolioValue}
              setListDataPortfolio={setListDataPortfolio}
              dataOptions={dataOptions}
              setDataOptions={setDataOptions}
            />
          </Col>
        </Row>
    </Layout>
  );
};

export default PortfolioValueManagement;
